export default __webpack_public_path__ + "react/static/code-step-thumb-991223fa8837ee42c1928c0fb0f050dd.png";